import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackView, trackInstall } from "../lib/analytics";

const SKIP = ["/admin", "/login", "/statistiche"];

export function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    const p = location.pathname;
    if (!SKIP.some((s) => p.startsWith(s))) trackView(p);
  }, [location.pathname]);
  useEffect(() => {
    const onInstalled = () => trackInstall();
    window.addEventListener("appinstalled", onInstalled);
    return () => window.removeEventListener("appinstalled", onInstalled);
  }, []);
  return null;
}
